import React, { RefObject, useMemo } from 'react';

const methodFactory = <T>(): [
  (key: string) => undefined | RefObject<T>,
  (key: string) => undefined | RefObject<T>,
] => {
  const map = new Map<string, RefObject<T>>();
  const setRef = (key: string): RefObject<T> => {
    const ref = React.createRef<T>();
    map.set(key, ref);
    return ref;
  };
  const getRef = (key: string): RefObject<T> | undefined => {
    const ref = map.get(key);
    return ref;
  };
  return [setRef, getRef];
};

export const useDynamicRefs = <T>(): [
  (key: string) => undefined | RefObject<T>,
  (key: string) => undefined | RefObject<T>,
] => {
  const refMethods = useMemo(() => methodFactory<T>(), []);
  return refMethods;
};
